"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react');






var _chat = require('shared/enum/chat');
var _entity = require('shared/enum/entity');
var _features = require('shared/enum/features'); var _features2 = _interopRequireDefault(_features);
var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _typed = require('shared/hooks/typed');
var _createNew = require('shared/selectors/createNew');
var _myRelations = require('shared/selectors/myRelations');
var _org = require('shared/selectors/org');
var _user = require('shared/selectors/user');
var _entity3 = require('shared/services/entity');
var _phone = require('shared/services/phone');
var _uuid = require('shared/services/uuid');
var _versionGuards = require('shared/services/versionGuards');


var _newChatFlow = require('shared/services/createNew/newChatFlow');
var _useSelectedEntities = require('./useSelectedEntities'); var _useSelectedEntities2 = _interopRequireDefault(_useSelectedEntities);
var _useDerivedSender = require('./useDerivedSender'); var _useDerivedSender2 = _interopRequireDefault(_useDerivedSender);
var _usePinnedOrgPolicy = require('./usePinnedOrgPolicy'); var _usePinnedOrgPolicy2 = _interopRequireDefault(_usePinnedOrgPolicy);
var _useSuggestedChat = require('./useSuggestedChat');







const noop = () => undefined
const EMPTY_ENTITIES = []

/* The state behind the New chat flow, shared by mobile and web: who's in To,
 * who it's from (today's rule: derived from To — one shared org sends as you,
 * one texting team in a patient's practice sends as that team — else the
 * inbox you're in — or picked in New group), Secure or SMS for a patient, the
 * optional name, the existing chat with the same people, and creating the
 * chat. */
 const useNewChat = ({ initialEntitiesList = EMPTY_ENTITIES, initialChannel = 'secure' } = {}) => {
  const hasPatientMessaging = !!_typed.useAppSelector.call(void 0, _user.selectCurrentUserHasPatientMessagingFeature)
  const { myEntitiesMap, defaultSenderKey, orgKeyContext } = _typed.useAppSelector.call(void 0, _createNew.selectNewChatSenderEnv)
  const myPhoneTeams = _typed.useAppSelector.call(void 0, _myRelations.selectMyPhoneTeamsList)
  const myActiveOrgKeys = _typed.useAppSelector.call(void 0, _user.selectMyActiveOrgKeysList)
  const orgs = _typed.useAppSelector.call(void 0, _org.selectOrgs)

  // To
  const {
    selectedEntitiesMap, selectedEntitiesList, onSelectEntity, onRemoveEntity, onFilterEntities, onResetEntities,
  } = _useSelectedEntities2.default.call(void 0, { initialEntitiesList })
  const patient = selectedEntitiesList.find(_entity3.isEntityPatient)
  const hasPatient = !!patient

  // From
  const [senderKey, setSenderKey] = _react.useState('')
  const senderEntity = (senderKey && myEntitiesMap[senderKey ]) || null
  const isSingleSender = Object.keys(myEntitiesMap).length <= 1
  const senderOrgKey = (_nullishCoalesce(_optionalChain([senderEntity, 'optionalAccess', _ => _.wrappedEntity, 'access', _2 => _2.OrgKey]), () => ( null))) 
  const hasWrittenSenderRef = _react.useRef.call(void 0, false)
  const pinnedOrgKeyRef = _react.useRef(null)
  const filterRecipientsForOrgRef = _react.useRef(noop)
  const handleSenderOrgChange = _react.useCallback.call(void 0, (newSenderKey) => {
    const newOrgKey = _optionalChain([myEntitiesMap, 'access', _3 => _3[newSenderKey], 'optionalAccess', _4 => _4.wrappedEntity, 'access', _5 => _5.OrgKey])
    const previousOrgKey = senderOrgKey || pinnedOrgKeyRef.current
    if (newOrgKey && previousOrgKey && newOrgKey !== previousOrgKey) {
      filterRecipientsForOrgRef.current(newOrgKey)
    }
  }, [myEntitiesMap, senderOrgKey])
  const applySender = _react.useCallback.call(void 0, (key) => {
    handleSenderOrgChange(key)
    hasWrittenSenderRef.current = true
    setSenderKey(key)
  }, [handleSenderOrgChange])
  const clearSender = _react.useCallback.call(void 0, () => {
    hasWrittenSenderRef.current = true
    setSenderKey('')
  }, [])
  const {
    ambiguous, pinnedOrgKey, markManual, resetStickiness, userClearGeneration, markNextEmptyAsFilterDriven,
  } = _useDerivedSender2.default.call(void 0, {
    recipients: selectedEntitiesList,
    senderKey,
    senderOrgKey,
    myPhoneTeams,
    myActiveOrgKeys,
    applySender,
    clearSender,
  })
  const { filterRecipientsForOrg, hasRecipientOrgConflict, patientPinnedOrgKey } = _usePinnedOrgPolicy2.default.call(void 0, {
    recipients: selectedEntitiesList,
    senderOrgKey,
    onFilterEntities,
    markNextEmptyAsFilterDriven,
  })
  filterRecipientsForOrgRef.current = filterRecipientsForOrg
  pinnedOrgKeyRef.current = pinnedOrgKey
  // Today's default sender, at first and again each time the user clears To,
  // whatever was derived or chosen before (a filter-driven clear keeps it).
  const handledClearRef = _react.useRef.call(void 0, 0)
  _react.useEffect.call(void 0, () => {
    if (userClearGeneration !== handledClearRef.current) {
      handledClearRef.current = userClearGeneration
      hasWrittenSenderRef.current = false
    }
    if (!defaultSenderKey || hasWrittenSenderRef.current) return
    hasWrittenSenderRef.current = true
    setSenderKey(defaultSenderKey )
  }, [defaultSenderKey, senderKey, userClearGeneration])
  // Picked in From (New group, or the patient step's real choice).
  const chooseSender = _react.useCallback.call(void 0, (key) => {
    markManual()
    applySender(key)
  }, [applySender, markManual])
  // Backing out of New group or the patient step drops what was chosen there,
  // so a one-to-one chat started next has no name and today's default sender.
  const [name, setName] = _react.useState.call(void 0, '')
  const resetChoices = _react.useCallback.call(void 0, () => {
    setName('')
    resetStickiness()
    if (defaultSenderKey) setSenderKey(defaultSenderKey )
  }, [resetStickiness, defaultSenderKey])
  const hasSenderOrgConflict = (!!pinnedOrgKey && senderOrgKey !== pinnedOrgKey) || hasRecipientOrgConflict

  // Secure or SMS, for one patient; Secure unless the link said SMS.
  const [channel, setChannel] = _react.useState(initialChannel)
  const hadPatient = _react.useRef.call(void 0, hasPatient)
  _react.useEffect.call(void 0, () => {
    if (hadPatient.current && !hasPatient) setChannel('secure')
    hadPatient.current = hasPatient
  }, [hasPatient])
  const patientOrgKey = patient ? (patient.wrappedEntity ).OrgKey : null
  const phoneTeamsForPatient = _react.useMemo.call(void 0, 
    () => myPhoneTeams.filter(t => !patientOrgKey || t.OrgKey === patientOrgKey),
    [myPhoneTeams, patientOrgKey],
  )
  const blockedReason = _newChatFlow.insecureBlockedReason.call(void 0, {
    hasPatientMessaging,
    hasPhoneTeam: phoneTeamsForPatient.length > 0,
    recipients: selectedEntitiesList,
  })
  const effectiveChannel = channel === 'insecure' && !blockedReason ? 'insecure' : 'secure'
  const chatType = _newChatFlow.chatTypeFor.call(void 0, hasPatient, effectiveChannel)
  const isInsecure = chatType === _chat.CHAT_TYPE.REGULAR_PATIENT
  // An SMS goes out from a team's number. With exactly one in the patient's
  // practice, From moves to it; with several, the user chooses: a patient
  // never gets a text from a number nobody picked.
  const isPhoneSender = !!senderEntity && _entity3.isEntityTeam.call(void 0, senderEntity) && !!(senderEntity.wrappedEntity ).PhoneNumber
  const onlyPhoneTeam = phoneTeamsForPatient.length === 1 ? phoneTeamsForPatient[0] : undefined
  _react.useEffect.call(void 0, () => {
    if (isInsecure && onlyPhoneTeam && !isPhoneSender) applySender(onlyPhoneTeam.TeamKey )
  }, [isInsecure, onlyPhoneTeam, isPhoneSender, applySender])
  const mustChooseSender = !!ambiguous || (isInsecure && !isPhoneSender && phoneTeamsForPatient.length > 1)
  const senderPhone = senderEntity && _entity3.isEntityTeam.call(void 0, senderEntity)
    ? _phone.formatPhoneNumber.call(void 0, (senderEntity.wrappedEntity ).PhoneNumber)
    : ''

  // The existing chat with exactly these people, From and channel.
  const lookupSender = selectedEntitiesList.length
    ? senderEntity 
    : null
  const { suggestedChat, isLoading: isMatching } = _useSuggestedChat.useSuggestedChat.call(void 0, {
    senderEntity: lookupSender,
    selectedEntitiesList,
    chatMethod: _newChatFlow.deliveryMethodFor.call(void 0, chatType),
    chatName: '',
    chatType,
  })
  const match = lookupSender ? suggestedChat : null
  const reusableMatch = _newChatFlow.canReuseMatch.call(void 0, isInsecure ? '' : name) ? match : null

  // Patients outside the chat's practice, teams outside a patient's, and
  // patients in a practice without patient messaging can't be added.
  const getDisabled = _react.useCallback.call(void 0, (entity) => {
    if (_entity3.isEntityPatient.call(void 0, entity) && !!pinnedOrgKey && entity.wrappedEntity.OrgKey !== pinnedOrgKey) return true
    if (_entity3.isEntityTeam.call(void 0, entity) && !!patientPinnedOrgKey && entity.wrappedEntity.OrgKey !== patientPinnedOrgKey) return true
    if (!_entity3.isEntityPatient.call(void 0, entity)) return false
    const patientOrg = orgs[entity.wrappedEntity.OrgKey] 
    return !!patientOrg && _versionGuards.isOrgV1.call(void 0, patientOrg) && !_org.orgHasFeature.call(void 0, patientOrg, _features2.default.PATIENT_MESSAGING)
  }, [orgs, patientPinnedOrgKey, pinnedOrgKey])

  // Why the chat can't be opened or created yet, or null.
  const blocker = !selectedEntitiesList.length
    ? 'Add someone in To first.'
    : isInsecure && !isPhoneSender
      ? 'Choose which team number this text comes from.'
      : !senderEntity || mustChooseSender || hasSenderOrgConflict
          ? 'Choose who this is from.'
          : null

  const createChat = _react.useCallback.call(void 0, async () => {
    // SAFETY: callers check `blocker` first.
    const sender = senderEntity
    const groups = _entity3.groupEntities.call(void 0, selectedEntitiesList.concat(sender))
    const patientKeys = _optionalChain([groups, 'access', _6 => _6[_entity.ENTITY_TYPES.PATIENT], 'optionalAccess', _7 => _7.map, 'call', _8 => _8(e => e.wrappedEntity.PatientKey)]) || []
    if (isInsecure) {
      return _actions2.default.createSmsConversation({
        TeamKey: (sender.wrappedEntity ).TeamKey,
        PatientKey: patientKeys[0],
      })
    }
    const userKeys = [
      ...(_optionalChain([groups, 'access', _9 => _9[_entity.ENTITY_TYPES.USER], 'optionalAccess', _10 => _10.map, 'call', _11 => _11(e => e.wrappedEntity.UserKey)]) || []),
      ...(_optionalChain([groups, 'access', _12 => _12[_entity.ENTITY_TYPES.RELATIONSHIP], 'optionalAccess', _13 => _13.map, 'call', _14 => _14(e => e.wrappedEntity.UserKey)]) || []),
    ].filter(key => key && key !== _uuid.EMPTY_BLUID)
    return _actions2.default.createConversation({
      OrgKey: sender.wrappedEntity.OrgKey,
      UserKeys: userKeys,
      TeamKeys: _optionalChain([groups, 'access', _15 => _15[_entity.ENTITY_TYPES.TEAM], 'optionalAccess', _16 => _16.map, 'call', _17 => _17(e => e.wrappedEntity.TeamKey)]) || [],
      PatientKeys: patientKeys,
      ..._newChatFlow.chatNameRequest.call(void 0, name),
    })
  }, [senderEntity, selectedEntitiesList, isInsecure, name])

  const searchOrgKey = senderOrgKey || pinnedOrgKey || orgKeyContext

  return {
    hasPatientMessaging,
    myEntitiesMap,
    orgKeyContext,
    searchOrgKey,
    // To
    selectedEntitiesMap,
    selectedEntitiesList,
    onSelectEntity,
    onRemoveEntity,
    onResetEntities,
    patient,
    getDisabled,
    pinnedOrgKey,
    patientPinnedOrgKey,
    resetStickiness,
    // From
    senderEntity,
    senderOrgKey,
    senderPhone,
    isSingleSender,
    chooseSender,
    mustChooseSender,
    isPhoneSender,
    phoneTeamsForPatient,
    // Secure / SMS
    channel: effectiveChannel,
    setChannel,
    blockedReason,
    chatType,
    isInsecure,
    // Name
    name,
    setName,
    resetChoices,
    // The existing chat
    match,
    reusableMatch,
    isMatching,
    // Create
    blocker,
    createChat,
  }
}; exports.useNewChat = useNewChat


